var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toggle-button',{attrs:{"value":_vm.product.active.value,"sync":true,"labels":_vm.$t('AdministrationProductActiveSwitch.switch'),"width":60},on:{"change":_vm.toggleProductActiveness}})}
var staticRenderFns = []

export { render, staticRenderFns }